import React, { useRef, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const InputPrimary = (props) => {
  const { type, label, name, value, error, onChange, onFocus, onBlur, icon, className } = props;

  const [textVisible, settextVisible] = useState("password");

  const inputRef = useRef();
  return (
    <div className={`input-primary ${className} ${value ? "input-active" : ""} ${error ? "input-error" : ""}`}>
      <input
        ref={inputRef}
        type={type === "password" ? textVisible : type}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {type === "password" &&
        (textVisible === "password" ? (
          <VisibilityIcon fontSize="small" onClick={() => settextVisible("text")} />
        ) : (
          <VisibilityOffIcon fontSize="small" onClick={() => settextVisible("password")} />
        ))}

      <label onClick={() => inputRef.current.focus()}>{error ? error : label}</label>
      <span />
    </div>
  );
};

export default InputPrimary;
